import { TreeItem } from "./TreeItem"




export const Treeview = ({tree, ...rest}) => {
    const {colorSvg, openSidebar, coutDelivery, countTable, selectedTheme} = rest

    return (
        tree.map(item => 
            <TreeItem 
                {...item}
                openSidebar={openSidebar}
                colorSvg={colorSvg}
                key={item.id} 
                item={item}
                coutDelivery={coutDelivery}
                selectedTheme={selectedTheme}
                countTable={countTable}
            />
        )
    )

}
